'use client';

import { useEffect, useState, type ReactNode } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import { MenuEntry } from '../menu/MenuEntry';

interface Props {
  children: ReactNode;
}

export function MainAppLayout({ children }: Props) {
  // You cannot get the current screen size on a server component, so any default will be incorrect in one case if you try to capture this in one variable.
  const [smallScreenDrawerOpen, setSmallScreenDrawerOpen] = useState(false);
  const [largeScreenDrawerOpen, setLargeScreenDrawerOpen] = useState(true);

  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const [isLargeScreen, setIsLargeScreen] = useState(matches);

  useEffect(() => {
    setIsLargeScreen(matches);
  }, [matches]);

  const handleToggleCurrentScreenDrawer = () => {
    if (isLargeScreen) {
      setLargeScreenDrawerOpen(!largeScreenDrawerOpen);
    } else {
      setSmallScreenDrawerOpen(!smallScreenDrawerOpen);
    }
  };

  return (
    <MenuEntry
      smallScreenDrawerOpen={smallScreenDrawerOpen}
      largeScreenDrawerOpen={largeScreenDrawerOpen}
      onToggleDrawer={handleToggleCurrentScreenDrawer}
    >
      {children}
    </MenuEntry>
  );
}
